/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

 $.fn.isInViewport = function () {
   let elementTop = $(this).offset().top;
   let elementBottom = elementTop + $(this).outerHeight();

   let viewportTop = $(window).scrollTop();
   let viewportBottom = viewportTop + window.innerHeight;

   return elementBottom > viewportTop && elementTop < viewportBottom;
 };

window.np = window.np || {
  customer: {},
  product: {},
  practitioner: {},
  cart: {},
  deal: {}
};

const $document = $(document);

/*************************
Product page
*************************/
/* Quantity Restriction */
np.product.maxQty = {
  init: ($dom = $document) => {
    const $blocks = $dom.find('div[data-max-quantity]:not([data-allowance])');

    $blocks.each((i, ele) => {
      const $productBlock = $(ele);

      // process max quantity on product page
      np.product.maxQty.process($productBlock, 0);

      // bind click event on add to cart button
      $productBlock.find('button[data-action="add-to-cart"]').on('click', () => {
        // listening to product added event to confirm product has been added, has to do this way as the theme event does not provide product id
        $document.one('product:added', e => {
          np.product.maxQty.process($productBlock, e.detail.quantity || 0);
        });
      });
    });

    // bind quantity selector on product page
    $blocks.find('.quantity-selector__value').on('input change paste keyup', e => {
      const productBlock = e.currentTarget.closest('[data-allowance]');

      if (productBlock && e.currentTarget.value > productBlock.dataset.allowance) {
        e.currentTarget.value = productBlock.dataset.allowance;
      }
    });
    $blocks.find('.quantity-selector--product').on('click', e => {
      if (e.target.classList.contains('quantity-selector__button')) {
        e.currentTarget.querySelector('.quantity-selector__value').dispatchEvent(new Event('input', {
          bubbles: true
        }));
      }
      if ($(e.target).hasClass('')) {
        $(e.currentTarget).find().trigger('change input');
      }
    });

    // if item is removed from mini cart / cart page
    $document.on('click', '[data-max-quantity] [class*="__quantity-remove"]', e => {
      $document.one('theme:loading:end', () => {
        np.product.maxQty.restore($(e.currentTarget).closest('[data-max-quantity]'));
      });
    });
  },
  process: ($productBlock, qtyAdded) => {
    const variantId = parseInt($productBlock.attr('data-variant-id'), 10);
    const qtyMax = parseInt($productBlock.attr('data-max-quantity'), 10);
    const $productBlocks = $(`[data-variant-id="${variantId}"][data-max-quantity]`);
    let qtyAllowance = Math.min.apply(Math, $productBlocks.map((i, block) => block.dataset.allowance).get().concat([qtyMax - np.cart.qtyInCart(variantId)]));

    qtyAllowance -= qtyAdded;
    $productBlock.attr('data-allowance', Math.max(0, qtyAllowance));
    $productBlock.find('.quantity-selector__value').trigger('change');
  },
  restore: ($productBlock) => {
    const variantId = parseInt($productBlock.attr('data-variant-id'), 10);
    const qtyMax = parseInt($productBlock.attr('data-max-quantity'), 10);
    const qtyInCart = parseInt($productBlock.find('.quantity-selector__value').val(), 10) || 1;

    $(`div[data-variant-id="${variantId}"]`).attr('data-allowance', (i, allowance) => Math.min(qtyMax, parseInt(allowance, 10) + qtyInCart));
    np.cart.update(variantId, qtyInCart);
  }
};

/* Consultation forms */
np.product.consultationForm = {
  init: () => {
    np.product.consultationForm.process();

    // listen to quick view modal
    var modal = document.querySelector('#modal-quick-view-collection-template');

    if (modal) {
      new MutationObserver(mutations => {
        mutations.forEach(mutation => {
          if (!mutation.target.classList.contains('is-loading')) {
            np.product.consultationForm.process();
          }
        });
      }).observe(modal, {
        attributes: true,
        attributeFilter: ['class']
      });
    }
  },
  process: () => {
    const $consultationForm = $('.product-consultation_form');

    if ($consultationForm.length > 0) {
      // toggle form when clicking form header
      $consultationForm.find('.product-consultation_form__title').on('click', () => {
        $consultationForm.toggleClass('collapsed expanded');
      });

      // toggle form when clicking toggle arrow
      $('.product-consultation_form__toggle').on('click', () => {
        $consultationForm.toggleClass('collapsed expanded');

        // scroll up when collapse the form
        const card = $consultationForm.closest('.card')[0];
        if (card && $consultationForm.hasClass('collapsed')) {
          const scrollTarget = document.querySelector('#modal-quick-view-collection-template[aria-hidden="false"]') || window;
          const amountToScroll = card.getBoundingClientRect().top - 15 - parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'));

          scrollTarget.scrollBy({
            top: amountToScroll,
            behavior: 'smooth'
          });
        }
      });

      // insert additional file upload field
      $consultationForm.find('.product-consultation_form__more').on('click', e => {
        const $upload = $consultationForm.find('[type="file"]:last-of-type');

        if ($upload.length == 1) {
          $upload.clone().prop('required', false).attr('name', (i, name) => name.replace(/\d/, match => ++match)).insertAfter($upload).on('click', evt => {
            const $newInput = $(evt.currentTarget);
            const cursorX = evt.pageX - $newInput.offset().left;

            if (cursorX > $newInput.innerWidth() - $newInput.innerHeight()) {
              evt.preventDefault();
              $newInput.remove();
            }
          });
        }
      });

      // toggle sub-form
      const $subForms = $consultationForm.find('.product-consultation_form__subForm');
      $subForms.first().find('input[type="radio"]').on('change', e => {
        $subForms.slice(1).hide().find('input, select, textarea').prop('disabled', true);
        $subForms.filter(`[data-sub-form=${e.target.dataset.subForm}]`).show().find('input, select, textarea').prop('disabled', false);
      });

      // calculate age
      $consultationForm.find('input[name="properties[BirthDay]"], select[name="properties[BirthMonth]"], input[name="properties[BirthYear]"]').on('change', e => {
        const birthDay = $consultationForm.find('input[name="properties[BirthDay]"]:visible').val();
        const birthMonth = $consultationForm.find('select[name="properties[BirthMonth]"]:visible').val();
        const birthYear = $consultationForm.find('input[name="properties[BirthYear]"]:visible').val();

        if (birthDay > 0 && birthMonth && birthMonth.length > 0 && birthYear > 0) {
          try {
            $consultationForm.find('input[name="properties[Age]"]').val(Math.abs(luxon.DateTime.fromFormat(`${birthDay}.${birthMonth}.${birthYear}`, 'd.MMMM.yyyy').diffNow('years').years).toFixed());
          } catch (error) {}
        }
      });

      // calculate BMI
      $consultationForm.find('input[name="properties[Height_cm]"], input[name="properties[Weight_kg]"]').on('change', e => {
        const height = parseInt($consultationForm.find('input[name="properties[Height_cm]"]:visible').val());
        const weight = parseInt($consultationForm.find('input[name="properties[Weight_kg]"]:visible').val());

        if (Number.isInteger(height) && height > 100 && Number.isInteger(weight) && weight > 0) {
          $consultationForm.find('input[name="properties[BMI]"]').val((weight / Math.pow(height / 100, 2)).toFixed(2));
        }
      });

      // merge checkbox inputs
      $consultationForm.find('.product-consultation_form--checkbox input[type="checkbox"]').on('change', e => {
        const $checkbox = $(e.target).closest('.product-consultation_form--checkbox');
        const $checkboxValue = $checkbox.find('input[type="hidden"]');

        if ($checkboxValue.length > 0) {
          $checkboxValue.val($checkbox.find('input[type="checkbox"]:checked').map((i, ele) => ele.value).get().join(', '));
        }
      });

      // override add to cart button to upload consultation form
      $('.product-form__add-button').on('click', e => {
        e.stopImmediatePropagation();
        e.stopPropagation();
        e.preventDefault();

        document.dispatchEvent(new CustomEvent('theme:loading:start'));
        e.currentTarget.setAttribute('disabled', '');

        var productForm = e.currentTarget.closest('form');

        // if not valid, trigger invalid UI
        if (!productForm.checkValidity()) {
          // scroll to the first invalid element
          var scrollTarget = document.querySelector('#modal-quick-view-collection-template[aria-hidden="false"]');
          var amountToScroll = e.currentTarget.getBoundingClientRect().top - 15 - parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'));

          if (!scrollTarget) {
            scrollTarget = window;
            amountToScroll -= 35;
          }

          $consultationForm.removeClass('collapsed').addClass('expanded');
          scrollTarget.scrollBy({
            top: amountToScroll,
            behavior: 'smooth'
          });

          e.currentTarget.removeAttribute('disabled');
          document.dispatchEvent(new CustomEvent('theme:loading:end'));

          $('<input type="submit">').hide().appendTo(productForm).click().remove();
        } else {
          productForm.submit();
        }
      });
    }
  }
};


/* misc functions */
np.product.parse = selector => {
  Array.from(selector.querySelectorAll('script.product-data')).forEach(script => {
    const productId = parseInt(script.dataset.productId, 10);

    np.product[productId] = JSON.parse(script.textContent.trim());

    // assign max quantity
    if (np.product[productId].tags.includes('Quantity Restricted')) {
      const maxQuantities = np.product[productId].tags.join(',').split(',max-').pop().split(',').shift().split('-');

      np.product[productId].variants.forEach((variant, index) => {
        variant.maxQuantity = parseInt(maxQuantities[index], 10);
      });
    }
  });
}
np.product.get = arg => {
  if (!arg || typeof arg === 'undefined' || (arg && arg.length === 0)) arg = '.card[data-product-id]';
  if (typeof arg === 'number') return np.product[arg];
  if (typeof arg === 'string') {
    if (!isNaN(arg)) return np.product[parseInt(arg, 10)];

    var card = document.querySelector(arg);

    if (card) return np.product[parseInt(card.dataset.productId, 10)];
  }

  return null;
};

/*************************
Deals
*************************/
np.deal = {
  campaigns: [],
  init: () => {
    const dealData = document.querySelector('#deal-data');

    if (dealData) {
      np.deal.campaigns = JSON.parse(dealData.textContent.trim())
      .sort((a, b) => a.priority - b.priority) // sort priority first
      .sort((a, b) => a.group != b.group ? a.group.length - b.group.length : 0) // sort by group
      .sort((a, b) => b.global_priority ? 1 : 0 - a.global_priority ? 1 : 0); // sort global priority
    }
  },
  isActive: campaign => {
    let active = false;

    // check if campaign still valid
    const dt = luxon.DateTime.local().setZone('Pacific/Auckland');
    const startDate = luxon.DateTime.fromISO(campaign.start_date, {
      zone: 'Pacific/Auckland'
    });
    const endDate = luxon.DateTime.fromISO(campaign.end_date, {
      zone: 'Pacific/Auckland'
    });

    if (dt > startDate && dt < endDate) {
      active = true;
    }

    // check if campaign on debug mode
    if (campaign.debug_mode) {
      active = np.customer.isLoggedIn && np.customer.email.includes('@netpharmacy.co.nz');
    }

    return active;
  },
  isEligible: (campaign, productId) => {
    const filter_brand = campaign.conditions.filter_by_brand.trim();
    const filter_collection = campaign.conditions.filter_by_collection.trim();
    const filter_tags = campaign.conditions.filter_by_tags.split(',').map(tag => tag.trim()).filter(tag => tag.length > 0);
    const filter_products = campaign.conditions.filter_by_products.toString().trim();
    const product = np.product.get(productId);
    let eligible = true;

    if (!product) {
      eligible = false;
    } else {
      if (filter_brand.length > 0 && filter_brand !== product.vendor) {
        eligible = false;
      }
      if (filter_collection.length > 0 && !product.collections.includes(filter_collection)) {
        eligible = false;
      }
      if (filter_tags.length > 0 && !filter_tags.every(tag => product.tags.includes(tag))) {
        eligible = false;
      }
      if (filter_products.length > 0 && !filter_products.includes(product.id.toString())) {
        eligible = false;
      }
    }

    return eligible;
  },
  applyToCart: async () => {
    try {
      let index = 0;
      let global_priority = false;
      let priority = 99;
      let group = '';
      const $cartForm = $('form[action="/cart"]');

      // remove previous appended gift items
      $cartForm.find('.gift-item').remove();

      // loop all gift campaigns
      for (let campaign of np.deal.campaigns) {
        // check campaign type
        if (campaign.type !== 'gwp') continue;

        // check global priority
        if (global_priority && !campaign.global_priority) continue;

        // check campaign priority
        if (group.length > 0 && group == campaign.group && campaign.priority > priority) continue;

        // check is campaign active
        if (!np.deal.isActive(campaign)) continue;

        // check gift item conditions then extract eligible items cart value & quantity
        let giftInCart = false;
        let cartValue = 0;
        let cartQuantity = 0;
        const response = await fetch(location.origin + '/cart.js', {
          method: 'GET',
          credentials: 'same-origin'
        });
        const cartData = await response.json();

        for (let item of cartData.items) {
          if (np.deal.isEligible(campaign, item.product_id)) {
            cartValue += item.final_line_price / 100;
            cartQuantity += item.quantity;
          }
          if (campaign.gift_product_id == item.product_id && campaign.gift_variant_id == item.variant_id) {
            giftInCart = true;
          }
        }

        // check gift cart conditions
        if (campaign.conditions.min_cart_value > 0 && campaign.conditions.min_cart_value > cartValue) continue;
        if (campaign.conditions.max_cart_value > 0 && campaign.conditions.max_cart_value < cartValue) continue;
        if (campaign.conditions.min_cart_quantity > 0 && campaign.conditions.min_cart_quantity > cartQuantity) continue;
        if (campaign.conditions.max_cart_quantity > 0 && campaign.conditions.max_cart_quantity < cartQuantity) continue;

        if (campaign.auto_add === false) {
          if (giftInCart === true) continue;

          const gift = np.product.get(campaign.gift_product_id);

          if (!gift.variants[0].available) continue;

          const $giftOffer = $(`
            <div class="container gift-offer">
              <p style="display: flex;">
                <span class="estimate-shipping__icon">
                  <svg focusable="false" viewBox="0 0 24 24" role="presentation">
                    <g stroke-width="2" fill="none" fill-rule="evenodd">
                      <path d="M3 18l9-9M11.9999905 23.0000095l9.0000152-9.0000143M5 23L19 9" stroke="#585858"></path>
                      <path stroke="#585858" stroke-linecap="square" d="M21 9v14H3V9"></path>
                      <path d="M6 3c0-1.1.9000001-2 2-2 3 0 4 4 4 4H8c-1.1000004 0-2-.9000001-2-2zM18 3c0-1.1-.8999996-2-2-2-3 0-4 4-4 4h4c1.1000004 0 2-.9000001 2-2z" stroke="#26a96c" stroke-linecap="square"></path>
                      <path stroke="#585858" stroke-linecap="square" d="M1 5h22v4H1z"></path>
                    </g>
                  </svg>
                </span>
                <span class="estimate-shipping__text" style="font-weight: bold;">Free Gift for You</span>
              </p>
              <p>${campaign.offer_message}</p>
              <p class="gift-offer_option gift-offer_option--accept"><strong>Yes</strong>, I want the gift.</p>
              <p class="gift-offer_option gift-offer_option--decline"><strong>No</strong>, I am not interested.</p>
            </div>
          `);

          $giftOffer.find('.gift-offer_option--accept').on('click', () => {
            fetch('/cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                items: [{
                  id: campaign.gift_variant_id,
                  quantity: 1
                }]
              })
            })
            .then(response => {
              if (response.ok) location.reload();
            })
            .catch(error => {
              console.error(error);
            });
          });
          $giftOffer.find('.gift-offer_option--decline').on('click', () => {
            $giftOffer.hide();
          });

          $('.page__description').after($giftOffer);
        } else {
          // append gift items
          const gift = np.product.get(campaign.gift_product_id);
          const giftVariant = gift.variants.find(v => v.id == campaign.gift_variant_id);
          const giftTitle = campaign.gift_title_override || (campaign.gift_variant_id && giftVariant ? giftVariant.name : gift.title);
          const giftImage = gift.gift_variant_id && giftVariant ? giftVariant.featured_image.src : gift.featured_image;
          const $giftItem = $cartForm.find('.line-item').first().clone(true).addClass('gift-item');
          let giftQuantity = 1;

          $giftItem.find('.line-item__delay-message').remove();

          // calculate gift quantity
          if (campaign.multiple_gift === true && (campaign.conditions.min_cart_value > 0 || campaign.conditions.min_cart_quantity > 0)) {
            const byCartValue = campaign.conditions.min_cart_value > 0 ? Math.floor(cartValue / campaign.conditions.min_cart_value) : -1;
            const byCartQuantity = campaign.conditions.min_cart_quantity > 0 ? Math.floor(cartQuantity / campaign.conditions.min_cart_quantity) : -1;

            giftQuantity = byCartValue > 0 && byCartQuantity > 0 ? Math.min(byCartValue, byCartQuantity) : Math.max(byCartValue, byCartQuantity);
          }

          // attache gift item details
          $giftItem.attr('data-product-id', campaign.gift_product_id);
          $giftItem.find('img').attr({
            src: giftImage,
            alt: gift.title
          });
          $giftItem.find('.line-item__vendor').attr('href', '#').text('Free Gift');
          $giftItem.find('.line-item__title').attr('href', gift.url).text(giftTitle);
          $giftItem.find('.quantity-selector').html(`<span>${giftQuantity}</span>`);
          $giftItem.find('.line-item__quantity-remove').replaceWith(
            $('<a class="line-item__quantity-remove link" href="#">Remove</a>').on('click', () => {
              $giftItem.remove();
              $cartForm.find('.gift-item').remove();
            })
          );
          $giftItem.find('.line-item__line-price span').text('Free');
          $giftItem.find('.line-item__price-list').remove();
          $cartForm.find('.line-item-table tbody').append($giftItem);
          index++;
          $cartForm.append(`<input type="hidden" class="gift-item" name="attributes[FreeGift_${index}]" value="${giftTitle} x ${giftQuantity}">`);
          sessionStorage.setItem(`FreeGift_${index}_image`, giftImage);
        }

        // update priority
        global_priority = campaign.global_priority;
        group = campaign.group;
        priority = campaign.priority;
      }
    } catch (e) {
      console.error(e);
    }
  },
  applyToProductPage: productId => {
    try {
      const $card = $('.card[data-product-id]');

      if ($card.length === 1) {
        const $deals = $('<div class="product-extra-info__deals"><h5>Deals</h5></div>');
        productId = productId || parseInt($card.attr('data-product-id'), 10);

        // loop all deal campaigns
        for (let campaign of np.deal.campaigns) {
          // check is campaign active
          if (!np.deal.isActive(campaign)) continue;

          // check product eligibility
          if (!np.deal.isEligible(campaign, productId)) continue;

          // check if ok to show
          if (campaign.show_on_product_page === false) continue;

          $deals.append(`<p>${campaign.description}</p>`);
        }

        if ($deals.children().length > 1) {
          $card.find('.product-extra-info').prepend($deals);
        }
      }
    } catch (e) {
      console.error(e);
    }
  },
  applyToPage: () => {
    try {
      const $content = $('.page__content');

      if (location.pathname === '/pages/deals' && $content.length === 1) {
        for (let campaign of np.deal.campaigns) {
          // check is campaign active
          if (!np.deal.isActive(campaign)) continue;

          const dateFormat = {
              hour12: true,
              year: 'numeric',
              month: 'long',
              day: '2-digit',
              weekday: 'long',
              hour: '2-digit',
              minute: '2-digit'
          };
          const startDate = luxon.DateTime.fromISO(campaign.start_date, {
            zone: 'Pacific/Auckland'
          }).setLocale('en-GB').toLocaleString(dateFormat);
          const endDate = luxon.DateTime.fromISO(campaign.end_date, {
            zone: 'Pacific/Auckland'
          }).setLocale('en-GB').toLocaleString(dateFormat);

          $content.append(`
            <div class="deals__campaign">
              <h4 class="deals__campaign__name">${campaign.name}</h4>
              <p class="deals__campaign__description">${campaign.description}</p>
              <p class="deals__campaign__date">Valid from <span class="deals__campaign__date--start">${startDate}</span> to <span class="deals__campaign__date--end">${endDate}</span> or while stocks last.</p>
            </div>
          `);
        }
      }
    } catch (e) {
      console.error(e);
    }
  }
};

/*************************
Practitioner
*************************/
np.practitioner = {
  infoButton: () => {
    // Practitioner range price info button
    const card = document.querySelector('.product-block-list__item--practitioner');

    if (card) {
      $('.product-practitioner_price_info > a').click(e => {
        e.preventDefault();
        window.scrollBy({
          top: card.getBoundingClientRect().top - 15 - parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height')),
          behavior: 'smooth'
        });
        card.querySelector('.expandable-content__toggle').click();
      });
    }
  },
  signupForm: () => {
    // Practitioner Ranges Access page
    if (np.customer.isLoggedIn) {
      $('.practitionerForm .notice, .practitionerForm .acerill-custom-form').toggle();
    }
  }
};

/*************************
Cart page
*************************/
np.cart.init = () => {
  // override submit action, need to check if logged in when a certain products are in cart
  // override submit action, need to check if terms & conditions checkbox is checked or not
  // attach event to document to capture all form submission, the cart form gets replaced if customers edited cart
  const $loginRequired = $('.cart-recap__login');

  $loginRequired.on('click', function () {
    setTimeout(function () {
      $('.header__action-item--account a[href*="/login"]:visible')[0].click();
    }, 50);
  });

  $('form[action="/cart"] input[name="terms"]').on('change', e => {
    const $terms = $('form[action="/cart"] input[name="terms"]');
    if ($terms.filter(':checked').length === $terms.filter(':not(:checked)').length) {
      $terms.not(e.currentTarget).prop('checked', e.currentTarget.checked);
    }
  });

  $document.on('submit', 'form[action="/cart"]', e => {
    const $terms = $('form[action="/cart"] input[name="terms"]');
    const $zip = $('#shipping-estimator-zip');
    const $checkedTerms = $terms.filter(':checked');

    if ($loginRequired.length > 0 || $checkedTerms.length === 0) {
      e.stopImmediatePropagation();
      e.stopPropagation();
      e.preventDefault();
    } else {
      // proceed to checkout
      // dispatch custom event
      document.dispatchEvent(new Event('begin_checkout'));
    }

    if ($loginRequired.length > 0) {
      $loginRequired.addClass('emphasise');
    }

    // remind users terms not checked
    if ($checkedTerms.length === 0) {
      $zip.prop('required', false);

      // remove required attribute for mobile terms checkbox if it's no longer visible so second checkbox can be shown when report validity
      const $termsMobile = $terms.filter('#termsOfUse--mobile');
      if ($termsMobile.is(':hidden') || !$termsMobile.isInViewport()) {
        $termsMobile.prop('required', false);
      }

      e.currentTarget.reportValidity();
      $zip.prop('required', true);
      $termsMobile.prop('required', true);
    }
  });
};
np.cart.qtyInCart = variantId => {
  let qty = 0;

  np.cart.items.forEach(item => {
    if (variantId === item.variant_id) {
      qty += item.quantity;
    }
  });

  return qty;
};
np.cart.update = (variantId, qty) => {
  np.cart.items.forEach(item => {
    if (variantId === item.variant_id) {
      item.quantity -= qty;
    }
  });
};

/*************************
Misc.
*************************/
np.helpSupport = {
  isOpen: false,
  init: () => {
    $document.on('click', '[data-action="toggle-help-support"]', np.helpSupport.toggle);
    $document.on('keyup', (e) => {
      // Escape pressed
      if (e.keyCode === 27 && np.helpSupport.isOpen) {
        np.helpSupport.toggle();
      }
    });
  },
  toggle: () => {
    const toggler = document.querySelector('.header__help-support-toggle');
    const content = document.querySelector('.help-support');

    if (toggler.getAttribute('aria-expanded') === 'false') {
      toggler.setAttribute('aria-expanded', 'true');
      content.setAttribute('aria-hidden', 'false');
    } else {
      toggler.setAttribute('aria-expanded', 'false');
      content.setAttribute('aria-hidden', 'true');
    }

    np.helpSupport.isOpen = !np.helpSupport.isOpen;
  }
};

/*************************
DOM ready event
*************************/
window.addEventListener('DOMContentLoaded', () => {
  // load on all pages
  np.product.parse(document);
  np.product.maxQty.init();
  np.deal.init();
  np.helpSupport.init();

  // Klaviyo sign-up form
  $document.on('click', '.klaviyo-form button[class*="DismissButton__closeButton"]', () => {
    $('.klaviyo-form').hide();
  });

  // determine pages
  if (location.pathname.includes('/products/')) {
    // product page
    np.product.consultationForm.init();
    np.practitioner.infoButton();
    np.practitioner.signupForm();
    np.deal.applyToProductPage();

    // update variant description on load
    $('.variant_description').hide().filter(`[data-variant="${$('.product-form__selected-value').text().trim()}"]`).show();
  } else if (location.pathname.startsWith('/collections/')) {
    // collection page
    // watching on collection page
    const collectionDynamicPart = document.querySelector('.collection__dynamic-part');

    if (collectionDynamicPart) {
      collectionDynamicPart.addEventListener('DOMSubtreeModified', () => {
        np.product.parse(collectionDynamicPart);
      });
    }
  } else if (location.pathname.startsWith('/pages/')) {
    // pages
    np.practitioner.signupForm();
    np.deal.applyToPage();
  } else if (location.pathname.startsWith('/cart')) {
    // cart page
    np.cart.init();
    np.deal.applyToCart();
  }

  // dispatch custom event when every customised stuff is loaded & parsed
  document.dispatchEvent(new Event('DOMContentLoaded:custom'));
});

/*************************
Product variant change event
*************************/
document.addEventListener('variant:changed', e => {
  const options = JSON.parse(document.querySelector('[data-section-id="product-template"]').getAttribute('data-section-settings'));
  const variant = e.detail.variant; // Gives you access to the whole variant details
  const $productBlock = $('.card[data-product-id]');

  // update variant ID
  $productBlock.attr('data-variant-id', variant.id);

  // variant description
  $('.variant_description').hide().filter(`[data-variant="${variant.title}"]`).show();

  // update Afterpay & Laybuy
  $('.product-form__price-info.laybuy .laybuy_price').text(`$${Math.round(variant.price / 6 + Number.EPSILON) / 100} NZD`);
  $('.product-form__price-info.afterpay .afterpay_price').text(`$${Math.round(variant.price / 4 + Number.EPSILON) / 100} NZD`);

  // update reward points
  const product = np.product.get();
  let rewardPoints = 0;

  if (product &&
    !product.tags.includes('ExcludeRewards') &&
    !product.tags.includes('Infant Formula') &&
    !product.tags.includes('Pharmacist Only Medicine') &&
    !product.tags.includes('Prescription Medicine') &&
    !product.tags.includes('Pharmacy Only Medicines')) {
    rewardPoints = Math.floor(variant.price / 100 * (window.reward_points_per_dollar || 10));
  }

  $('.product-form__reward.points').attr('data-reward-points', rewardPoints).find('span').text(rewardPoints);

  // update stock availability
  if (variant.available) {
    document.querySelector('.product-form__info-item--inventory').classList.toggle('low', variant.inventory_quantity <= options.lowInventoryThreshold);
  }

  // update max quantity
  product.variants.forEach(v => {
    if (variant.id == v.id) {
      $productBlock.attr('data-max-quantity', v.maxQuantity);
      $productBlock.find('.product-extra-info__quantity-restriction .max-quantity').text(v.maxQuantity);
      $productBlock.removeAttr('data-allowance');
      np.product.maxQty.process($productBlock, 0);
    }
  });
});

/*************************
Product added event
*************************/
document.addEventListener('product:added', (e) => {
  console.log(e);
});

/*************************
document.body mutation event
*************************/
new MutationObserver(mutations => {
  mutations.forEach(mutation => {
    Array.from(mutation.addedNodes).forEach(addedNode => {
      const $addedNode = $(addedNode);

      // init quantity restriction
      np.product.maxQty.init($addedNode);

      // watch added cart form after cart item quantity update then apply deal campaigns to cart
      if ($addedNode.is('form[action="/cart"]')) {
        np.deal.applyToCart();
      }

      // parse product data from lazy loaded flickity
      if (addedNode.classList && addedNode.classList.contains('flickity-viewport')) {
        np.product.parse(addedNode);
      }
    });
  });
}).observe(document.body, {
  subtree: true,
  childList: true
});
